/* eslint-disable react-hooks/exhaustive-deps */
import { Locale, Path, StoreKey } from "@common/constans";
import { DeviceType } from "@common/enum";
import { Locality } from "@common/models";
import { Dialog } from "@components/general/dialog";
import RateUs from "@components/general/RateUs";
import ItineraryContent from "@components/itinerary/ItineraryContent";
import { Culture } from "@core/Culture";
import { AppAction, IAppAction } from "@misc/Action";
import { IAppState } from "@misc/State";
import Config from "@service/Config";
import Notification from "@service/Notification";
import { Action, pnrInformation, rateUs, recentPnrInformation } from "@service/proxy";
import Storage from "@service/Storage";
import Translate from "@service/Translate";
import { isMobile } from "@utilize/Util";
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";

const Itinerary: FC = () => {
    const { tr } = Translate;
    const { push } = useHistory();
    const dispatch = useDispatch();
    const { code } = Culture.getLocale();
    const { pathname } = useLocation();
    const query = new URLSearchParams(useLocation().search);
    const { pnrInfo, routes } = useSelector((state: IAppState) => ({
        pnrInfo: state.pnrInfo,
        routes: state.routes
    }));
    const [printEnItinerary, setPrintEnItinerary] = useState<boolean>(false);
    const [satisfactionDialog, setSatisfactionDialog] = useState<boolean>(false);

    useEffect(() => {
        const transactionIdentifier = query.get("transactionId");
        const pnr = query.get("pnr") || "";
        const departureDate = +(query.get("date") || "0");
        const contactLastName = query.get("name") || "";
        if (!pnrInfo?.pnr) {
            dispatch<IAppAction>({ type: AppAction.Preloader, payload: { preloader: { show: true, message: tr("payment_preparing_ticket") } } });
            (transactionIdentifier ? recentPnrInformation(Action.POST, { data: { transactionIdentifier } }) : pnrInformation(Action.POST, { data: { pnr, departureDate, contactLastName } }))
                .then((response) => {
                    const pnrInfo = response.content;
                    dispatch<IAppAction>({ type: AppAction.PnrInfo, payload: { pnrInfo } });
                    setTimeout(() => setSatisfactionDialog(true), 3000);
                })
                .catch(() => {
                    push(Path.Home);
                })
                .finally(() => {
                    dispatch<IAppAction>({ type: AppAction.Preloader, payload: { preloader: { show: false, message: "" } } });
                })
        } else {
            setTimeout(() => setSatisfactionDialog(true), 3000);
        }
    }, []);

    useEffect(() => {
        if (pnrInfo.originDestinations?.length && routes.length) {
            pnrInfo.originDestinations.forEach(od => {
                const route = routes.find(r => r.origin === od.origin.code && r.destination === od.destination.code);
                if (route && route.locality === Locality.International && code !== Locale.en) {
                    setPrintEnItinerary(true);
                }
            })
        }
    }, [routes, pnrInfo]);

    const onSubmit = (rate: number, comment: string): Promise<boolean> => {
        return new Promise((resolve, reject) => {
            let deviceType = DeviceType.Desktop;
            if (isMobile()) {
                deviceType = DeviceType.Tablet
                if (window.innerWidth <= Config.config.viewport.small)
                    deviceType = DeviceType.Mobile;
            }
            rateUs(Action.POST, {
                data: {
                    pnr: pnrInfo.pnr,
                    rate,
                    comment,
                    deviceType
                }
            })
                .then(() => {
                    resolve(true);
                    setSatisfactionDialog(false);
                    Notification.success(tr("rate_us_msg_successful"));
                    Storage.set(StoreKey.RateUs, rate);
                })
                .catch(() => {
                    reject();
                })
        })
    }

    return (
        <div className="itinerary">
            <ItineraryContent printMode={printEnItinerary ? 'en' : undefined} />
            <Dialog
                animate="fade"
                show={pathname === Path.Booking.Itinerary && !Storage.get(StoreKey.RateUs) && satisfactionDialog}
                onHiding={() => setSatisfactionDialog(false)}
                className="rate-us-dialog"
            >
                <RateUs
                    maxRate={5}
                    onSubmit={onSubmit}
                    onHiding={() => setSatisfactionDialog(false)}
                />
            </Dialog>
        </div>
    )
}

export default Itinerary;
